import React from 'react';
import { Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import EmptyState from './common/EmptyState';

const UnauthorizedPage = () => {
  const navigate = useNavigate();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      padding={3}
    >
      <EmptyState 
        title="Access Denied" 
        description="You don't have permission to access this resource."
      />
      
      <Button 
        variant="contained" 
        color="primary" 
        onClick={() => navigate('/')}
        sx={{ mt: 4 }}
      >
        Go to Home
      </Button>
    </Box>
  );
};

export default UnauthorizedPage; 